import styled, { css } from 'styled-components';
import CorUtil from '../../functions/corUtil';

const variacaoDePreenchimento = {
  alerta: css`
    background-color: ${(props) => CorUtil.rgba(props.theme['WARNING'], 0.1)};
    border-left: solid 5px ${(props) => props.theme['WARNING']};
  `,
  erro: css`
    background-color: ${(props) => CorUtil.rgba(props.theme['DANGER'], 0.1)};
    border-left: solid 5px ${(props) => props.theme['DANGER']};
  `,
  info: css`
    background-color: ${(props) => CorUtil.rgba(props.theme['INFO'], 0.1)};
    border-left: solid 5px ${(props) => props.theme['INFO']};
  `,
  sucesso: css`
    background-color: ${(props) => CorUtil.rgba(props.theme['SUCCESS'], 0.1)};
    border-left: solid 5px ${(props) => props.theme['SUCCESS']};
  `,
};

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;

  width: 92%;
  padding: 10px 15px;

  border-radius: 5px 15px 15px 5px;

  ${(props) => variacaoDePreenchimento[props.preenchimento]}
`;

export const Titulo = styled.header`
  margin-bottom: 1rem;

  font-size: 1rem;
  font-weight: 700;
`;
